import React, { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  Divider,
  Button,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  IconButton
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useQuery, useMutation } from "@apollo/client";

// icon
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import { FaFileCsv } from "react-icons/fa6";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from '@mui/icons-material/MoreVert';


// src
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import AttendanceAction from "./AttendanceAction";
import GenerateAttendanceByDay from "./GenerateAttendanceByDay";
import SelectDatePicker from "../Include/SelecteDatePicker/SelectDatePicker";

import {
  GET_ATTENDANCE_BY_CLASS,
  UPDATE_ATTENDANCE,
} from "../../Schema/Attendance";
import moment from "moment";

import AttendanceBtnMenu from "./AttendanceBtnMenu"
import StudentAttendanceAction from "./StudentAttendanceAction";

import ExportStudentAttendanceCSV from "./CVSFile/ExportStudentAttendanceCSV";
import ImportStudentAttendanceDialog from "./CVSFile/ImportStudentAttendanceDialog";

export default function CheckAttendancePage({ classId }) {
  // Change Language
  const { language, setAlert } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  // const [stuData, setStuData] = useState()

  const [dateVal, setDateVal] = useState(moment());

  const { refetch } = useQuery(GET_ATTENDANCE_BY_CLASS, {
    variables: {
      classId: classId,
      attendanceDate: moment(dateVal)?.format("YYYY-MM-DD"),
    },
    onCompleted: ({ getAttendanceByClass }) => {
      setTableData(getAttendanceByClass);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const [updateAttendance] = useMutation(UPDATE_ATTENDANCE, {
    onCompleted: ({ updateAttendance }) => {
      // console.log("updateAttendance::", updateAttendance);
      setLoading(false);
      if (updateAttendance?.is_success === true) {
        setAlert(true, "success", updateAttendance?.message);
        // setRefetch();
      } else {
        setAlert(true, "error", updateAttendance?.message);
        // console.log("updateAttendance?.message::", updateAttendance?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      // console.log("error::", error);

    },
  });


  const handleSetReason = (id, value) => {


    const newData = tableData.map((e) => {
      if (id === e.class_attended?._id) {
        return {
          ...e,
          reason: value,
        };
      }
      return e;
    });

    // console.log("newData :", newData);
    setTableData(newData);
  };

  const handleUpdateReason = async (stuId, reasons) => {
    setLoading(true);
    // console.log("first", stuId, reasons);
    await updateAttendance({
      variables: {
        id: stuId,
        input: {
          reason: reasons,
        },
      },
    });
  };

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    refetch();
  }, []);

  

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  console.log(tableData, "tableData::");
  return (
    <div>
      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`date`)}
            </Typography>
            <SelectDatePicker date={dateVal} setDate={(e) => setDateVal(e)} />
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 8, lg: 9, xl: 10 }}>
            <Stack direction="row" justifyContent="right">
              <Button
                id="demo-customized-button"
                aria-controls={open ? "demo-customized-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                className="btn-create-style"
                endIcon={<KeyboardArrowDownIcon />}
              >
                {t("options")}
              </Button>
              <AttendanceBtnMenu

                open={open}
                handleClose={handleClose}
                anchorEl={anchorEl}

                classId={classId}
                setRefetch={refetch}
                tableData={tableData}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px`, whiteSpace: "nowrap" }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-start"
                      : "header-title-start-kh"
                  }
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_student_id")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_student_name")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_latin_name")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_gender")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("page-attendance")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("reason")}
                </TableCell>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-end"
                      : "header-title-end-kh"
                  }
                ></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="table-body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="table-body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-start"
                                  : "body-cell-start-kh"
                              }
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {String(row?.student_id?.student_id ?? "").padStart(4, "0")}
                              {/* {row?.student_id?.student_id} */}
                            </TableCell>
                            <TableCell className="body-cell-kh">
                              {row?.student_id?.full_name_kh}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.student_id?.full_name_latin}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.student_id?.gender}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              <AttendanceAction
                                setRefetch={refetch}
                                dateVal={dateVal}
                                attended_id={row?.class_attended?._id}
                                editData={row}
                              />
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              <TextField
                                size="small"
                                fullWidth
                                value={row?.reason}
                                type="text"
                                onChange={({ target }) => {
                                  handleSetReason(
                                    row?.class_attended?._id,
                                    target.value
                                  );
                                }}
                                onBlur={() => {
                                  // console.log("បានដកម៉ៅចេញហើយបងរ៉ុង!!")
                                  // console.log("row ", row);
                                  handleUpdateReason(
                                    row?._id,
                                    row?.reason,
                                  );
                                }}
                              />
                            </TableCell>

                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-end"
                                  : "body-cell-end-kh"
                              }
                              align="right"
                            >
                              <StudentAttendanceAction stuData={row} enrollmentTypeAction="att_page" setRefetch={refetch} />

                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>


    </div>
  );
}
